import { ERROR_MESSAGES } from '../../constants';

const validation = (test, error, variables = null) =>
  test ? { valid: test } : { valid: false, error, variables };

const inputLength = maxLength => value =>
  validation(value.length <= maxLength, ERROR_MESSAGES.length, {
    max_length: maxLength,
  });

const validateEmail = value => {
  const emailRegExp =
    // eslint-disable-next-line max-len
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return validation(emailRegExp.test(value.toLowerCase()), ERROR_MESSAGES.email);
};

const validatePhoneAreaCode = value => {
  const phoneRegExp = /^(45|50|51|53|57|60|66|69|72|73|78|79|88)/;
  return validation(phoneRegExp.test(value.replace(/ /g, '')), ERROR_MESSAGES.phoneAreaCode);
};

const validatePhone = value => {
  const phoneRegExp = /^(45|50|51|53|57|60|66|69|72|73|78|79|88)[0-9]{7}$/;
  return validation(phoneRegExp.test(value.replace(/ /g, '')), ERROR_MESSAGES.phone);
};

// Calculated based on https://pl.wikipedia.org/wiki/Numer_identyfikacji_podatkowej
// and on https://gist.github.com/amadeuszblanik/d76b029b2b16e44e507c555dbc8edaf5#file-validationnip-ts
const isValidCheckSumForPolishVAT = value => {
  const splittedValue = String(value).split('');
  const controlValues = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  const partialSums = controlValues.map(
    (controlValue, index) => controlValue * parseInt(splittedValue[index], 10),
  );

  let sum = 0;
  partialSums.forEach(partialSum => {
    sum += partialSum;
  });

  const control = sum % 11;

  return parseInt(splittedValue[9], 10) === control;
};

const validateVat = value => {
  const vatRegExp = /^[0-9]{10}$/;
  const isValidLength = vatRegExp.test(value.replace(/ /g, ''));
  const isValidVAT = isValidCheckSumForPolishVAT(value);
  const isValid = isValidLength && isValidVAT;
  const validationMessage =
    (!isValidLength && ERROR_MESSAGES.vatNumberLength) ||
    (!isValidVAT && ERROR_MESSAGES.vatNumberFormat) ||
    null;

  return validation(isValid, validationMessage);
};

export default {
  validation,
  inputLength,
  validateEmail,
  validatePhoneAreaCode,
  validatePhone,
  validateVat,
  isValidCheckSumForPolishVAT,
};
